export default __webpack_public_path__ + "static/media/immoOx-Text.002b70d3.png";